import "../../../shared/sparkle_backbone.js";
import "../../../utilities/generate_uuid.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Models ??= {};

AssessmentBuilder.Models.Base = class Base extends Backbone.RelationalModel {
  // Syntactic sugar
  static initializeRelations() {
    this.setup();
  }

  static guid() {
    return Sparkle.Utilities.generateUUID();
  }
};
